module.exports = __webpack_public_path__ + "img/credit-card-front-duotone.8e67b19c.svg";